import React, { useEffect, useState } from "react";
import PublicNavbar from "../../components/Navbars/PublicNavbar";
import { Container } from "reactstrap";
import AuthFooter from "../../components/Footers/AuthFooter";
import CreateResourceComponent from "../../components/CreateResourceComponent";
import { fetchServices } from "../../http/http-calls";
import { showToast } from "../../helper-methods";

const Resources = () => {
  const [services, setServices] = useState([]);

  const _fetchAllServices = async () => {
    try {
      const res = await fetchServices();
      console.log("allservices", res);
      setServices(res?.data);
    } catch (error) {
      console.log("error", error);
      showToast(
        error.reason && error.reason.length
          ? error.reason
          : "Server error. Try again after sometime.",
        "error"
      );
    }
  };
  useEffect(() => {
    _fetchAllServices();
  }, []);
  return (
    <div className="vayco-admin public-protected">
      {/* //Protected Routes */}
      <div className="wrapper">
        <div className="main-panel">
          <PublicNavbar />
          <div className="content">
            <div className="mb-5"></div>
            <Container fluid className="mobilePadding-0">
              <CreateResourceComponent services={services} />
            </Container>
          </div>
          <AuthFooter />
        </div>
      </div>
    </div>
  );
};

export default Resources;
